/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SubscriptionCancelCommand } from '../models';
// @ts-ignore
import type { SubscriptionInitPaymentCommand } from '../models';
// @ts-ignore
import type { SubscriptionInitPaymentResponseDto } from '../models';
// @ts-ignore
import type { SubscriptionResponseDto } from '../models';
/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SubscriptionCancelCommand} [subscriptionCancelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionCancelPost: async (subscriptionCancelCommand?: SubscriptionCancelCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionCancelCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orderId] 
         * @param {number} [merchantId] 
         * @param {string} [amount] 
         * @param {string} [currency] 
         * @param {string} [orderStatus] 
         * @param {string} [signature] 
         * @param {string} [tranType] 
         * @param {string} [senderCellPhone] 
         * @param {string} [senderAccount] 
         * @param {string} [maskedCard] 
         * @param {number} [cardBin] 
         * @param {string} [cardType] 
         * @param {string} [rrn] 
         * @param {string} [approvalCode] 
         * @param {string} [responseCode] 
         * @param {string} [responseDescription] 
         * @param {string} [reversalAmount] 
         * @param {string} [settlementAmount] 
         * @param {string} [settlementCurrency] 
         * @param {string} [orderTime] 
         * @param {string} [settlementDate] 
         * @param {string} [eci] 
         * @param {string} [fee] 
         * @param {string} [paymentSystem] 
         * @param {string} [senderEmail] 
         * @param {number} [paymentId] 
         * @param {string} [actualAmount] 
         * @param {string} [actualCurrency] 
         * @param {string} [productId] 
         * @param {string} [merchantData] 
         * @param {string} [verificationStatus] 
         * @param {string} [rectoken] 
         * @param {string} [rectokenLifetime] 
         * @param {string} [additionalInfo] 
         * @param {string} [responseStatus] 
         * @param {string} [errorMessage] 
         * @param {string} [errorCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionPaymentCompletePost: async (orderId?: string, merchantId?: number, amount?: string, currency?: string, orderStatus?: string, signature?: string, tranType?: string, senderCellPhone?: string, senderAccount?: string, maskedCard?: string, cardBin?: number, cardType?: string, rrn?: string, approvalCode?: string, responseCode?: string, responseDescription?: string, reversalAmount?: string, settlementAmount?: string, settlementCurrency?: string, orderTime?: string, settlementDate?: string, eci?: string, fee?: string, paymentSystem?: string, senderEmail?: string, paymentId?: number, actualAmount?: string, actualCurrency?: string, productId?: string, merchantData?: string, verificationStatus?: string, rectoken?: string, rectokenLifetime?: string, additionalInfo?: string, responseStatus?: string, errorMessage?: string, errorCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/payment/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (orderId !== undefined) { 
                localVarFormParams.append('order_id', orderId as any);
            }
    
            if (merchantId !== undefined) { 
                localVarFormParams.append('merchant_id', merchantId as any);
            }
    
            if (amount !== undefined) { 
                localVarFormParams.append('amount', amount as any);
            }
    
            if (currency !== undefined) { 
                localVarFormParams.append('currency', currency as any);
            }
    
            if (orderStatus !== undefined) { 
                localVarFormParams.append('order_status', orderStatus as any);
            }
    
            if (signature !== undefined) { 
                localVarFormParams.append('signature', signature as any);
            }
    
            if (tranType !== undefined) { 
                localVarFormParams.append('tran_type', tranType as any);
            }
    
            if (senderCellPhone !== undefined) { 
                localVarFormParams.append('sender_cell_phone', senderCellPhone as any);
            }
    
            if (senderAccount !== undefined) { 
                localVarFormParams.append('sender_account', senderAccount as any);
            }
    
            if (maskedCard !== undefined) { 
                localVarFormParams.append('masked_card', maskedCard as any);
            }
    
            if (cardBin !== undefined) { 
                localVarFormParams.append('card_bin', cardBin as any);
            }
    
            if (cardType !== undefined) { 
                localVarFormParams.append('card_type', cardType as any);
            }
    
            if (rrn !== undefined) { 
                localVarFormParams.append('rrn', rrn as any);
            }
    
            if (approvalCode !== undefined) { 
                localVarFormParams.append('approval_code', approvalCode as any);
            }
    
            if (responseCode !== undefined) { 
                localVarFormParams.append('response_code', responseCode as any);
            }
    
            if (responseDescription !== undefined) { 
                localVarFormParams.append('response_description', responseDescription as any);
            }
    
            if (reversalAmount !== undefined) { 
                localVarFormParams.append('reversal_amount', reversalAmount as any);
            }
    
            if (settlementAmount !== undefined) { 
                localVarFormParams.append('settlement_amount', settlementAmount as any);
            }
    
            if (settlementCurrency !== undefined) { 
                localVarFormParams.append('settlement_currency', settlementCurrency as any);
            }
    
            if (orderTime !== undefined) { 
                localVarFormParams.append('order_time', orderTime as any);
            }
    
            if (settlementDate !== undefined) { 
                localVarFormParams.append('settlement_date', settlementDate as any);
            }
    
            if (eci !== undefined) { 
                localVarFormParams.append('eci', eci as any);
            }
    
            if (fee !== undefined) { 
                localVarFormParams.append('fee', fee as any);
            }
    
            if (paymentSystem !== undefined) { 
                localVarFormParams.append('payment_system', paymentSystem as any);
            }
    
            if (senderEmail !== undefined) { 
                localVarFormParams.append('sender_email', senderEmail as any);
            }
    
            if (paymentId !== undefined) { 
                localVarFormParams.append('payment_id', paymentId as any);
            }
    
            if (actualAmount !== undefined) { 
                localVarFormParams.append('actual_amount', actualAmount as any);
            }
    
            if (actualCurrency !== undefined) { 
                localVarFormParams.append('actual_currency', actualCurrency as any);
            }
    
            if (productId !== undefined) { 
                localVarFormParams.append('product_id', productId as any);
            }
    
            if (merchantData !== undefined) { 
                localVarFormParams.append('merchant_data', merchantData as any);
            }
    
            if (verificationStatus !== undefined) { 
                localVarFormParams.append('verification_status', verificationStatus as any);
            }
    
            if (rectoken !== undefined) { 
                localVarFormParams.append('rectoken', rectoken as any);
            }
    
            if (rectokenLifetime !== undefined) { 
                localVarFormParams.append('rectoken_lifetime', rectokenLifetime as any);
            }
    
            if (additionalInfo !== undefined) { 
                localVarFormParams.append('additional_info', additionalInfo as any);
            }
    
            if (responseStatus !== undefined) { 
                localVarFormParams.append('response_status', responseStatus as any);
            }
    
            if (errorMessage !== undefined) { 
                localVarFormParams.append('error_message', errorMessage as any);
            }
    
            if (errorCode !== undefined) { 
                localVarFormParams.append('error_code', errorCode as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubscriptionInitPaymentCommand} [subscriptionInitPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionPaymentInitPost: async (subscriptionInitPaymentCommand?: SubscriptionInitPaymentCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/payment/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionInitPaymentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SubscriptionCancelCommand} [subscriptionCancelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubscriptionCancelPost(subscriptionCancelCommand?: SubscriptionCancelCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubscriptionCancelPost(subscriptionCancelCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.apiSubscriptionCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubscriptionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubscriptionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.apiSubscriptionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [orderId] 
         * @param {number} [merchantId] 
         * @param {string} [amount] 
         * @param {string} [currency] 
         * @param {string} [orderStatus] 
         * @param {string} [signature] 
         * @param {string} [tranType] 
         * @param {string} [senderCellPhone] 
         * @param {string} [senderAccount] 
         * @param {string} [maskedCard] 
         * @param {number} [cardBin] 
         * @param {string} [cardType] 
         * @param {string} [rrn] 
         * @param {string} [approvalCode] 
         * @param {string} [responseCode] 
         * @param {string} [responseDescription] 
         * @param {string} [reversalAmount] 
         * @param {string} [settlementAmount] 
         * @param {string} [settlementCurrency] 
         * @param {string} [orderTime] 
         * @param {string} [settlementDate] 
         * @param {string} [eci] 
         * @param {string} [fee] 
         * @param {string} [paymentSystem] 
         * @param {string} [senderEmail] 
         * @param {number} [paymentId] 
         * @param {string} [actualAmount] 
         * @param {string} [actualCurrency] 
         * @param {string} [productId] 
         * @param {string} [merchantData] 
         * @param {string} [verificationStatus] 
         * @param {string} [rectoken] 
         * @param {string} [rectokenLifetime] 
         * @param {string} [additionalInfo] 
         * @param {string} [responseStatus] 
         * @param {string} [errorMessage] 
         * @param {string} [errorCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubscriptionPaymentCompletePost(orderId?: string, merchantId?: number, amount?: string, currency?: string, orderStatus?: string, signature?: string, tranType?: string, senderCellPhone?: string, senderAccount?: string, maskedCard?: string, cardBin?: number, cardType?: string, rrn?: string, approvalCode?: string, responseCode?: string, responseDescription?: string, reversalAmount?: string, settlementAmount?: string, settlementCurrency?: string, orderTime?: string, settlementDate?: string, eci?: string, fee?: string, paymentSystem?: string, senderEmail?: string, paymentId?: number, actualAmount?: string, actualCurrency?: string, productId?: string, merchantData?: string, verificationStatus?: string, rectoken?: string, rectokenLifetime?: string, additionalInfo?: string, responseStatus?: string, errorMessage?: string, errorCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubscriptionPaymentCompletePost(orderId, merchantId, amount, currency, orderStatus, signature, tranType, senderCellPhone, senderAccount, maskedCard, cardBin, cardType, rrn, approvalCode, responseCode, responseDescription, reversalAmount, settlementAmount, settlementCurrency, orderTime, settlementDate, eci, fee, paymentSystem, senderEmail, paymentId, actualAmount, actualCurrency, productId, merchantData, verificationStatus, rectoken, rectokenLifetime, additionalInfo, responseStatus, errorMessage, errorCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.apiSubscriptionPaymentCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SubscriptionInitPaymentCommand} [subscriptionInitPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubscriptionPaymentInitPost(subscriptionInitPaymentCommand?: SubscriptionInitPaymentCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionInitPaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubscriptionPaymentInitPost(subscriptionInitPaymentCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.apiSubscriptionPaymentInitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionCancelCommand} [subscriptionCancelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionCancelPost(subscriptionCancelCommand?: SubscriptionCancelCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSubscriptionCancelPost(subscriptionCancelCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionGet(options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponseDto> {
            return localVarFp.apiSubscriptionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orderId] 
         * @param {number} [merchantId] 
         * @param {string} [amount] 
         * @param {string} [currency] 
         * @param {string} [orderStatus] 
         * @param {string} [signature] 
         * @param {string} [tranType] 
         * @param {string} [senderCellPhone] 
         * @param {string} [senderAccount] 
         * @param {string} [maskedCard] 
         * @param {number} [cardBin] 
         * @param {string} [cardType] 
         * @param {string} [rrn] 
         * @param {string} [approvalCode] 
         * @param {string} [responseCode] 
         * @param {string} [responseDescription] 
         * @param {string} [reversalAmount] 
         * @param {string} [settlementAmount] 
         * @param {string} [settlementCurrency] 
         * @param {string} [orderTime] 
         * @param {string} [settlementDate] 
         * @param {string} [eci] 
         * @param {string} [fee] 
         * @param {string} [paymentSystem] 
         * @param {string} [senderEmail] 
         * @param {number} [paymentId] 
         * @param {string} [actualAmount] 
         * @param {string} [actualCurrency] 
         * @param {string} [productId] 
         * @param {string} [merchantData] 
         * @param {string} [verificationStatus] 
         * @param {string} [rectoken] 
         * @param {string} [rectokenLifetime] 
         * @param {string} [additionalInfo] 
         * @param {string} [responseStatus] 
         * @param {string} [errorMessage] 
         * @param {string} [errorCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionPaymentCompletePost(orderId?: string, merchantId?: number, amount?: string, currency?: string, orderStatus?: string, signature?: string, tranType?: string, senderCellPhone?: string, senderAccount?: string, maskedCard?: string, cardBin?: number, cardType?: string, rrn?: string, approvalCode?: string, responseCode?: string, responseDescription?: string, reversalAmount?: string, settlementAmount?: string, settlementCurrency?: string, orderTime?: string, settlementDate?: string, eci?: string, fee?: string, paymentSystem?: string, senderEmail?: string, paymentId?: number, actualAmount?: string, actualCurrency?: string, productId?: string, merchantData?: string, verificationStatus?: string, rectoken?: string, rectokenLifetime?: string, additionalInfo?: string, responseStatus?: string, errorMessage?: string, errorCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSubscriptionPaymentCompletePost(orderId, merchantId, amount, currency, orderStatus, signature, tranType, senderCellPhone, senderAccount, maskedCard, cardBin, cardType, rrn, approvalCode, responseCode, responseDescription, reversalAmount, settlementAmount, settlementCurrency, orderTime, settlementDate, eci, fee, paymentSystem, senderEmail, paymentId, actualAmount, actualCurrency, productId, merchantData, verificationStatus, rectoken, rectokenLifetime, additionalInfo, responseStatus, errorMessage, errorCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionInitPaymentCommand} [subscriptionInitPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionPaymentInitPost(subscriptionInitPaymentCommand?: SubscriptionInitPaymentCommand, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionInitPaymentResponseDto> {
            return localVarFp.apiSubscriptionPaymentInitPost(subscriptionInitPaymentCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionCancelCommand} [subscriptionCancelCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public apiSubscriptionCancelPost(subscriptionCancelCommand?: SubscriptionCancelCommand, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).apiSubscriptionCancelPost(subscriptionCancelCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public apiSubscriptionGet(options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).apiSubscriptionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [orderId] 
     * @param {number} [merchantId] 
     * @param {string} [amount] 
     * @param {string} [currency] 
     * @param {string} [orderStatus] 
     * @param {string} [signature] 
     * @param {string} [tranType] 
     * @param {string} [senderCellPhone] 
     * @param {string} [senderAccount] 
     * @param {string} [maskedCard] 
     * @param {number} [cardBin] 
     * @param {string} [cardType] 
     * @param {string} [rrn] 
     * @param {string} [approvalCode] 
     * @param {string} [responseCode] 
     * @param {string} [responseDescription] 
     * @param {string} [reversalAmount] 
     * @param {string} [settlementAmount] 
     * @param {string} [settlementCurrency] 
     * @param {string} [orderTime] 
     * @param {string} [settlementDate] 
     * @param {string} [eci] 
     * @param {string} [fee] 
     * @param {string} [paymentSystem] 
     * @param {string} [senderEmail] 
     * @param {number} [paymentId] 
     * @param {string} [actualAmount] 
     * @param {string} [actualCurrency] 
     * @param {string} [productId] 
     * @param {string} [merchantData] 
     * @param {string} [verificationStatus] 
     * @param {string} [rectoken] 
     * @param {string} [rectokenLifetime] 
     * @param {string} [additionalInfo] 
     * @param {string} [responseStatus] 
     * @param {string} [errorMessage] 
     * @param {string} [errorCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public apiSubscriptionPaymentCompletePost(orderId?: string, merchantId?: number, amount?: string, currency?: string, orderStatus?: string, signature?: string, tranType?: string, senderCellPhone?: string, senderAccount?: string, maskedCard?: string, cardBin?: number, cardType?: string, rrn?: string, approvalCode?: string, responseCode?: string, responseDescription?: string, reversalAmount?: string, settlementAmount?: string, settlementCurrency?: string, orderTime?: string, settlementDate?: string, eci?: string, fee?: string, paymentSystem?: string, senderEmail?: string, paymentId?: number, actualAmount?: string, actualCurrency?: string, productId?: string, merchantData?: string, verificationStatus?: string, rectoken?: string, rectokenLifetime?: string, additionalInfo?: string, responseStatus?: string, errorMessage?: string, errorCode?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).apiSubscriptionPaymentCompletePost(orderId, merchantId, amount, currency, orderStatus, signature, tranType, senderCellPhone, senderAccount, maskedCard, cardBin, cardType, rrn, approvalCode, responseCode, responseDescription, reversalAmount, settlementAmount, settlementCurrency, orderTime, settlementDate, eci, fee, paymentSystem, senderEmail, paymentId, actualAmount, actualCurrency, productId, merchantData, verificationStatus, rectoken, rectokenLifetime, additionalInfo, responseStatus, errorMessage, errorCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionInitPaymentCommand} [subscriptionInitPaymentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public apiSubscriptionPaymentInitPost(subscriptionInitPaymentCommand?: SubscriptionInitPaymentCommand, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).apiSubscriptionPaymentInitPost(subscriptionInitPaymentCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

